import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Container, Text } from '@pixi/react';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { userInfoStore } from '../../../../store/userInfoStore';

function CreateTextWinAmountAndCurrencySymbol({
  x,
  y,
  color = '#FFC33E',
  amount,
  margin,
  fontSize = 16,
}) {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      fontWeight: 700,
      fontFamily: 'poppinsMedium',
      fill: color,
      align: 'center',
    };
  }, [fontSize, color]);

  const winRef = useRef(null);
  const [currencyCodeTestX, setCurrencyCodeTestX] = useState(0);

  useEffect(() => {
    if (winRef.current) {
      setCurrencyCodeTestX(winRef.current.width / 2 + margin);
    }
  }, [margin, winRef]);

  return (
    <Container x={x} y={y}>
      <Text
        ref={winRef}
        anchor={0.5}
        text={amount ? isoStandard(amount) : ''}
        style={styles}
        resolution={2}
      />
      <Text
        x={currencyCodeTestX}
        anchor={0.5}
        text={amount && userInfoStore.currencySymbol}
        style={styles}
        resolution={2}
      />
    </Container>
  );
}

export default CreateTextWinAmountAndCurrencySymbol;
